import { useSelector } from 'react-redux';
import { RootState } from '$store/rootReducer';

export function useAnimeFull(animeId) {
  return useSelector(({ anime }: RootState) => anime.animeInfo[animeId]);
}
